import _typeof from "@babel/runtime/helpers/esm/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _excluded = ["form"];
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck StatusMessage props
// FIXME: Need to fix StatusMessage types
import React from 'react';
import classNames from 'classnames/bind';
import { Form } from 'react-final-form';
import { StatusMessage, Text } from '@s7/ui-kit'; // TODO: DS-1533

import { ProviderSwitcher } from '../ProviderSwitcher';
import { noop } from '../utils';
import AuthorizationGroupField from './AuthorizationGroupField';
import AuthorizationGroupButton from './AuthorizationGroupButton';
import styles from './AuthorizationGroup.css';
var cx = classNames.bind(styles);

var renderText = function renderText(text, wrap, className, color, getTestId) {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    React.createElement("div", _extends({
      className: cx(className, _defineProperty({}, "".concat(className, "_noWrap"), !wrap))
    }, getTestId === null || getTestId === void 0 ? void 0 : getTestId('infoMessage')), wrap ? /*#__PURE__*/React.createElement(Text, {
      color: color
    }, text) : text)
  );
};

var renderFields = function renderFields(fields, wrap, form) {
  return /*#__PURE__*/React.createElement("div", {
    className: cx('Fields')
  }, wrap ? Object.keys(fields).map(function (name) {
    return /*#__PURE__*/React.createElement(AuthorizationGroupField, {
      field: fields[name],
      form: form,
      key: name,
      name: name
    });
  }) : fields);
};

var renderActions = function renderActions(actions, wrap, form) {
  return /*#__PURE__*/React.createElement("div", {
    className: cx('Actions')
  }, wrap ? actions.map(function (action, i) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(AuthorizationGroupButton, {
        action: action,
        form: form,
        key: i
      })
    );
  }) : actions);
};

var renderFormContent = function renderFormContent(_ref, formRenderProps) {
  var fields = _ref.fields,
      wrapFields = _ref.wrapFields,
      actions = _ref.actions,
      wrapActions = _ref.wrapActions;
  return /*#__PURE__*/React.createElement(React.Fragment, null, fields && renderFields(fields, wrapFields, formRenderProps), actions && renderActions(actions, wrapActions, formRenderProps));
};

var renderForm = function renderForm(params) {
  if (params.form) {
    var form = params.form,
        rest = _objectWithoutProperties(params, _excluded);

    return /*#__PURE__*/React.createElement(Form, form, function (formRenderProps) {
      return /*#__PURE__*/React.createElement("form", {
        className: cx('Form'),
        onSubmit: formRenderProps.handleSubmit
      }, renderFormContent(rest, formRenderProps));
    });
  }

  return renderFormContent(params);
};

var AuthorizationGroup = function AuthorizationGroup(_ref2) {
  var actions = _ref2.actions,
      bottom = _ref2.bottom,
      fields = _ref2.fields,
      form = _ref2.form,
      heading = _ref2.heading,
      headingColor = _ref2.headingColor,
      info = _ref2.info,
      notification = _ref2.notification,
      providerSwitcher = _ref2.providerSwitcher,
      wrapActions = _ref2.wrapActions,
      wrapFields = _ref2.wrapFields,
      wrapHeading = _ref2.wrapHeading,
      wrapInfo = _ref2.wrapInfo,
      _ref2$getTestId = _ref2.getTestId,
      getTestId = _ref2$getTestId === void 0 ? noop : _ref2$getTestId;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('AuthorizationGroup')
  }, heading && renderText(heading, wrapHeading, 'Heading', headingColor, getTestId), notification && _typeof(notification) === 'object' && /*#__PURE__*/React.createElement("div", {
    className: cx('Notification')
  }, /*#__PURE__*/React.createElement(StatusMessage, notification)), providerSwitcher && /*#__PURE__*/React.createElement(ProviderSwitcher, null), renderForm({
    actions: actions,
    fields: fields,
    form: form,
    getTestId: getTestId,
    wrapActions: wrapActions,
    wrapFields: wrapFields
  }), info && renderText(info, wrapInfo, 'Info'), bottom && /*#__PURE__*/React.createElement("div", {
    className: cx('Bottom')
  }, bottom));
};

AuthorizationGroup.defaultProps = {
  headingColor: 'N900',
  wrapActions: true,
  wrapFields: true,
  wrapHeading: true,
  wrapInfo: true
};
export default AuthorizationGroup;